import { jsx as c, jsxs as v } from "react/jsx-runtime";
import { c as n } from "./index-Cu0xwYjD.js";
import { useMemo as k } from "react";
import { BREAKPOINTS as m, GlobalCSSClass as u } from "./utils/enums.js";
import { propagateTestid as M } from "./utils/helpers.js";
const N = "ids-slider-v501", p = "ids-slider--control-v501", S = "ids-slider--tick-mark-list-v501", h = "ids-slider--tick-mark-v501", f = "ids-slider--selected-v501", O = "ids-slider--tick-mark-label-v501", $ = "ids-slider--thumb-value-v501", i = {
  slider: N,
  control: p,
  tickMarkList: S,
  tickMark: h,
  selected: f,
  tickMarkLabel: O,
  thumbValue: $
}, T = (a, e, t, l, r) => {
  var o;
  const s = e === 0 ? a - r : a - (((o = t[e - 1]) == null ? void 0 : o.value) ?? 0);
  return `${Number(s / (l - r) * 100)}%`;
}, y = (a) => m.reduce(
  (e, t, l) => {
    var r, s;
    return {
      ...e,
      className: {
        ...e.className,
        [`${u.SROnly}--${t}`]: !!(((r = e.hiddenOn) == null ? void 0 : r[t]) ?? ((s = e.className) == null ? void 0 : s[`${u.SROnly}--${m[l - 1]}`]))
      }
    };
  },
  { ...a, className: {} }
), b = ({
  max: a = 10,
  min: e = 0,
  tickLabels: t = [],
  ...l
}) => {
  const r = k(
    () => t.map((s) => s.hiddenOn ? y(s) : s),
    [t]
  );
  return /* @__PURE__ */ c("datalist", { className: i.tickMarkList, ...l, children: r.map((s, d) => /* @__PURE__ */ v(
    "div",
    {
      className: n(i.tickMark, {
        [i.isMax]: a === s.value
      }),
      style: {
        "--iress-tick-label-width": T(
          s.value,
          d,
          t,
          a,
          e
        )
      },
      children: [
        /* @__PURE__ */ c(
          "option",
          {
            value: s.value,
            "data-testid": M(l["data-testid"], "option")
          }
        ),
        /* @__PURE__ */ c(
          "div",
          {
            className: n(i.tickMarkLabel, s.className),
            children: s.label || `${s.value}`
          }
        )
      ]
    },
    s.value
  )) });
};
export {
  b as S,
  i as s
};
